import type { RewardedAdProvider, ShowRewardedOptions } from "./adPorts.js";

export class RoutingRewardedAdProvider implements RewardedAdProvider {
  private native: RewardedAdProvider | null = null;

  constructor(
    private readonly house: RewardedAdProvider,
    private readonly mobileShare: number,
    private readonly rng: () => number = Math.random,
    private readonly forceHouse: () => boolean = () => false,
  ) {}

  setNativeProvider(provider: RewardedAdProvider): void {
    this.native = provider;
  }

  showRewarded(opts: ShowRewardedOptions): void {
    const useHouse =
      this.forceHouse() || this.native === null || this.rng() < this.mobileShare;
    (useHouse ? this.house : this.native!).showRewarded(opts);
  }
}
